import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { EtaModule } from '../eta/eta.module';
import { InlineEditComponentModule } from '../inline-edit/inline-edit.module';
import { TripMapOverlayComponent } from './trip-map-overlay.component';

@NgModule({
  declarations: [TripMapOverlayComponent],
  imports: [CommonModule, FormsModule, MatButtonModule, MatMenuModule, MatIconModule],
  exports: [TripMapOverlayComponent]
})
export class TripMapOverlayModule {}
